import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaHeart } from "react-icons/fa";
import "../newsletter.css";
import UnauthorizedNavbar from "./unauthorizedNavbar";
import UnauthorizedFooter from "./unauthorizedFooter";

const NewsLetterAndBlogsTemplate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { id: urlId } = useParams(); // Assuming route is like /blogs/:id
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const token = window.sessionStorage.getItem("jwtToken");

    const [newsletterData, setNewsletterData] = useState(null);
    const [likesCount, setLikes] = useState(0);
    const [likedStatus, setLikedStatus] = useState(false);
    const [htmlContent, setHtmlContent] = useState("");
    const [relatedBlogs, setRelatedBlogs] = useState([]);
    const { slug } = useParams();



useEffect(() => {
    const fetchBlog = async () => {
        try {
            // 1. Fetch ALL blogs from DB
            const res = await fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`);
            const allBlogs = await res.json();

            // 2. Find blog whose HTML file matches slug
            const blog = allBlogs.find(b => 
                b.htmlPageLink &&
                b.htmlPageLink.includes(`${slug}.html`)
            );

            if (!blog) {
                console.error("No blog found for slug:", slug);
                return;
            }

            // 3. Set blog metadata
            setNewsletterData(blog);

            // 4. Fetch HTML content
            const htmlRes = await fetch(`https://bossinvestor.in/htmlpages/${slug}.html`);
            let html = await htmlRes.text();

            html = html
                .replace(/<header>/g, `<header class="newsletter-header-content">`)
                .replace(/<p>/g, `<p class="newsletter-paragraph">`)
                .replace(/<img /g, `<img class="newsletter-image-content" `)
                .replace(/<ul>/g, `<ul class="newsletter-list">`)
                .replace(/<li>/g, `<li class="newsletter-list-item">`);

            setHtmlContent(html);

        } catch (error) {
            console.error("Error loading blog by slug:", error);
        }
    };

    fetchBlog();
}, [slug]);


    useEffect(() => {
        if (!newsletterData) return;

        const currentCategories = Array.isArray(newsletterData.categories)
            ? newsletterData.categories
            : newsletterData.categories
            ? newsletterData.categories.split(",").map(s => s.trim())
            : [];

        fetch(`${BASE_URL}/fetchNewsLetterAndBlogs`)
            .then(res => res.json())
            .then(all => {
                const list = Array.isArray(all) ? all : [];

                const normalized = list.map(n => ({
                    ...n,
                    categories: Array.isArray(n.categories)
                        ? n.categories
                        : n.categories
                        ? n.categories.split(",").map(s => s.trim())
                        : []
                }));

                const related = normalized
                    .filter(n => n.id !== newsletterData.id)
                    .filter(n =>
                        n.categories.some(cat =>
                            currentCategories.includes(cat)
                        )
                    )
                    .slice(0, 4); // ← show only top 4

                setRelatedBlogs(related);
            });
    }, [newsletterData]);


    // Scroll to top when blog ID changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [slug]);




    if (!newsletterData) return <div>Loading...</div>;

    return (
        <>
        <UnauthorizedNavbar />
        <div className="newsletter-page-wrapper">
        <div className="newsletter-container">
            {/* Fixed Header */}
            {/* Content Section */}
            <div className="newsletter-content">
                {/* Fixed Text Area */}
                <h1>{newsletterData.text}</h1>
                <p className="news-description">{newsletterData.description}</p>
                <div className="newsletter-meta">
                    {/* Company Logo */}
                    <img src="/bossinvestorLogo.png"
                         alt="BossInvestor Logo"style={{height:'38px', width:'38px'}} />
                    
                    {/* Text and Date */}
                    <div className="newsletter-meta-info">
                        <h6>BOSSINVESTOR</h6>
                        <small className="text-muted">{new Date(newsletterData.publishedDate).toDateString()}</small>
                    </div>
                </div>

                {/* Fixed Image */}
                <img src={newsletterData.backgroundImage} alt="Newsletter" className=" newsletter-image" />

                {/* Dynamic Content */}
                <div className="newsletter-dynamic-content" dangerouslySetInnerHTML={{ __html: htmlContent }} />

                <div style={{ marginTop: "60px" }}>
                    <h4 className="fw-bold mb-4">Related Blogs</h4>

                    {relatedBlogs.length === 0 ? (
                        <p>No related blogs found.</p>
                    ) : (
                        relatedBlogs.map(blog => (
                        <div
                            key={blog.id}
                            className="related-blog-card"
                            onClick={() => navigate(`/blogs/${blog.id}`, { state: blog })}
                        >
                            <img src={blog.backgroundImage} className="related-blog-image" />
                            <div>
                                <h4 className="font-semibold text-sm md:text-xl related-blog-title">{blog.text}</h4>
                                <small className="text-muted">
                                    Published: {new Date(blog.publishedDate).toDateString()}
                                </small>

                                <br />
                                <a
                                    style={{ color: "#6c2bd9", fontWeight: "bold", cursor: "pointer" }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        const fileName = blog.htmlPageLink
                                            ?.split("/")
                                            ?.pop()
                                            ?.replace(".html", "");
                                        navigate(`/blogs/${fileName}`);
                                    }}
                                >
                                    Read more…
                                </a>
                            </div>
                        </div>
                        ))
                    )}
                </div>


            </div>
        </div>
        </div>
        <UnauthorizedFooter />
        </>
    );
};

export default NewsLetterAndBlogsTemplate;
